<template>
<div class="chapter">
<div class="inner_page">
<h1>Copyright</h1>
<p class="sectiontop" style="text-align: center;">Distributed by Radius Book Group<br/>
  A Division of Diversion Publishing Corp.<br/>
  443 Park Avenue South, Suite 1008<br/>
  New York, NY 10016<br/>
<a href="http://www.radiusbookgroup.com" target="_blank">www.RadiusBookGroup.com</a></p>
<p class="sectiontop" style="text-align: center;">Copyright © 2016 by Tim Ryan<br/>
  All rights reserved, including the right to reproduce this book or portions thereof in any form whatsoever.</p>
<p class="sectiontop" style="text-align: center;">For more information, email <a href="mailto:info@diversionbooks.com">info@diversionbooks.com</a>.</p>
<p class="sectiontop" style="text-align: center;">First edition: September 2016<br/>
  eBook ISBN: 978-1-68230-675-8<br/>
  Hardcover ISBN: 978-1-68230-674-1</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Copyright.vue?55b7a22a